import { render, staticRenderFns } from "./CategoriesCreateModal.vue?vue&type=template&id=5c235644&"
import script from "./CategoriesCreateModal.vue?vue&type=script&lang=js&"
export * from "./CategoriesCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports